// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"4ab7aa72","239":"2f822dd7","396":"6a7c99d5","455":"f32529e2","977":"4288e1ed"}[chunkId] + ".chunk.js";
};